import { render } from "./ClientRequestView.vue?vue&type=template&id=9ce74fe6"
import script from "./ClientRequestView.vue?vue&type=script&lang=js"
export * from "./ClientRequestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__